import { IdResidence } from 'civil-status/constants/id-residence';
import { ParentVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { defaultChoicePickerState } from 'shell/components/shared/choice-date/constants';
import { ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';
import { SubjectAnpr } from 'shell/models/act-category-list';

export const transformerParent = (values?: SubjectAnpr): ParentVM | undefined => {
  if (!values) {
    return;
  }

  const isForeignBorn = values.idStatoNascita !== ID_ITALIAN_NATION?.toString();
  const typeResidence = values.idStatoResidenza
    ? values.idStatoResidenza === ID_ITALIAN_NATION?.toString()
      ? IdResidence.Italian
      : IdResidence.Foreign
    : IdResidence.NotKnown;

  return {
    searchPerson: {
      birthdayDateChoice: values.dataNascita ? defaultChoicePickerState : undefined,
      birthdayDate: values.dataNascita ? DateTime.fromISO(values.dataNascita) : undefined,
      fiscalCode: values.codiceFiscale || '',
      name: values.nome || '',
      surname: values.cognome || '',
      gender: values.sesso || '',
      idAnpr: values.idsoggettoanpr || '',
    },
    generality: {
      idAnsc: values.id || '',
      idAnpr: values.idsoggettoanpr || '',
      idNationalIdentifier: values.idANPR || '',
      name: values.nome || '',
      surname: values.cognome || '',
      gender: values.sesso || '',
      civilStatusItem: {
        id: values.idstatocivile || '',
        value: values.descrizionestatocivile || '',
      },
      formatBirthDate: values.idFormatodata
        ? {
            id: values.idFormatodata,
            value: values.formatodata || '',
          }
        : undefined,

      age: values.anni ? Number.parseInt(values.anni, 10) : undefined,
      birthDate: values.dataNascita ? DateTime.fromISO(values.dataNascita) : null,
      fiscalCode: values.codiceFiscale || '',
      nationality: {
        id: values.idNazionalita || '',
        idAnpr: values.idNazionalita ? Number.parseInt(values.idNazionalita, 10) : undefined,
        value: values.nazionalita || '',
      },
      isForeignBorn,
      italian: isForeignBorn
        ? undefined
        : {
            municipality: {
              code: values.idComuneNascita
                ? Number.parseInt(values.idComuneNascita, 10)
                : undefined,
              id: values.idComuneNascita || '',
              idProvince: values.idProvinciaNascita
                ? Number.parseInt(values.idProvinciaNascita, 10)
                : undefined,
              description: values.nomeComuneNascita || '',
              province: values.siglaProvinciaNascita || '',
            },
          },
      foreign: isForeignBorn
        ? {
            state: {
              code: values.idStatoNascita || '',
              id: values.idStatoNascita || '',
              value: values.nomeStatoNascita || '',
            },
            municipality: {
              id: values.idComuneNascita || '',
              idProvince: values.idProvinciaNascita
                ? Number.parseInt(values.idProvinciaNascita, 10)
                : undefined,
              description: values.nomeComuneNascita || '',
              province: values.siglaProvinciaNascita || '',
            },
            locationForeignBirth: values.localitaEsteraNascita || '',
          }
        : undefined,
      typeResidence,
      italianResidence:
        typeResidence === IdResidence.Italian
          ? {
              municipality: {
                code: values.idComuneResidenza
                  ? Number.parseInt(values.idComuneResidenza, 10)
                  : undefined,
                id: values.idComuneResidenza || '',
                idProvince: values.idProvinciaResidenza
                  ? Number.parseInt(values.idProvinciaResidenza, 10)
                  : undefined,
                description: values.nomeComuneResidenza || '',
                province: values.siglaProvinciaResidenza || '',
              },
            }
          : undefined,
      foreignResidence:
        typeResidence === IdResidence.Foreign
          ? {
              state: {
                code: values.idStatoResidenza || '',
                id: values.idStatoResidenza || '',
                value: values.nomeStatoResidenza || '',
              },
              municipality: {
                id: values.idComuneResidenza || '',
                idProvince: values.idProvinciaResidenza
                  ? Number.parseInt(values.idProvinciaResidenza, 10)
                  : undefined,
                description: values.nomeComuneResidenza || '',
                province: values.siglaProvinciaResidenza || '',
              },
              municipalityAire: {
                id: values.idComuneAIRE || '',
                code: values.idComuneAIRE ? Number.parseInt(values.idComuneAIRE, 10) : undefined,
                idProvince: values.idProvinciaAIRE
                  ? Number.parseInt(values.idProvinciaAIRE, 10)
                  : undefined,
                description: values.nomeComuneAIRE || '',
                province: values.siglaProvinciaAIRE || '',
              },
            }
          : undefined,
      address: values.indirizzoResidenza || '',
    },
  };
};
